module.exports = __webpack_public_path__ + "static/blog-06-5565d2aaa069a79dc5401abfdd0712cf.jpg";